const adminProfile = {
  actions: {
    close: 'Close personal settings',
  },
  errors: {
    accountUnavailable: 'This admin account is unavailable. Contact a super admin.',
    currentPasswordIncorrect: 'The current password is incorrect.',
    forbidden: 'You do not have permission to perform this action.',
    generic: 'The operation failed. Please try again later.',
    missingPasswordFields: 'Enter the current password and the new password.',
    network: 'Network error. Check your connection and try again.',
    serviceUnavailable: 'The service is unavailable. Please try again later.',
    sessionExpired: 'Your session has expired. Sign in again.',
  },
  fallbackName: 'Admin',
  fields: {
    confirmPassword: 'Confirm new password',
    currentPassword: 'Current password',
    displayName: 'Name',
    newPassword: 'New password',
  },
  loadErrorDescription: 'Could not read the current admin account.',
  nameEditor: {
    cancel: 'Cancel',
    close: 'Close name editor',
    edit: 'Edit name',
    placeholder: 'Enter the admin display name',
    submit: 'Save name',
    title: 'Edit name',
  },
  password: {
    cancel: 'Cancel',
    close: 'Close password editor',
    hidePassword: 'Hide password',
    modalTitle: 'Change password',
    reloginNotice:
      'After the password is saved, this admin session will be revoked and returned to the admin login page.',
    reset: 'Reset password',
    showPassword: 'Show password',
    submit: 'Save password',
    title: 'Password',
  },
  success: {
    passwordChanged: 'Password updated. Sign in again.',
    profileSaved: 'Personal info saved',
  },
  tabs: {
    basic: 'Basic info',
    label: 'Personal settings sections',
  },
  title: 'Personal settings',
  validation: {
    confirmPasswordMismatch: 'The new passwords do not match.',
    currentPasswordRequired: 'Enter your current password.',
    nameRequired: 'Name is required.',
    newPasswordLength: 'The new password must be at least 8 characters.',
  },
}

export default adminProfile
